import { ScrollArea } from "@veritrellis/ui";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useAccessManifest } from "../hooks/useAccessManifest.js";
import { useCurrentRole } from "../hooks/useCurrentRole.js";
import { useWorkspaceId } from "../hooks/useWorkspaceId.js";
import { filterSettingsNavGroups } from "../lib/settingsNav.js";

export const SettingsLayout = () => {
  const location = useLocation();
  const { workspaceId } = useWorkspaceId();
  const { role } = useCurrentRole();
  const manifestQ = useAccessManifest(workspaceId);

  const navGroups = filterSettingsNavGroups({
    role,
    manifestCan: manifestQ.data?.manifest.can
  });

  const isWideContent =
    location.pathname === "/settings/members" ||
    location.pathname === "/settings/api-keys" ||
    location.pathname === "/settings/access" ||
    location.pathname === "/settings/billing" ||
    location.pathname === "/settings/connectors" ||
    location.pathname === "/settings/approver-groups";

  return (
    <div className="admin-settings-shell">
      <aside className="admin-settings-nav" aria-label="Settings sections">
        <ScrollArea className="admin-settings-nav-scroll">
          {navGroups.map((group) => (
            <div key={group.id} className="admin-settings-nav-group">
              <p className="admin-settings-nav-group-label">{group.label}</p>
              <ul className="admin-settings-nav-list">
                {group.items.map((item) => {
                  const Icon = item.icon;
                  const isActive =
                    location.pathname === item.to ||
                    (item.to === "/settings/account" && location.pathname === "/settings");
                  return (
                    <li key={item.to}>
                      <Link
                        to={item.to}
                        className={
                          isActive
                            ? "admin-settings-nav-link admin-settings-nav-link--active"
                            : "admin-settings-nav-link"
                        }
                        aria-current={isActive ? "page" : undefined}
                      >
                        <Icon
                          className="admin-settings-nav-icon"
                          strokeWidth={isActive ? 2 : 1.5}
                        />
                        {item.label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </ScrollArea>
      </aside>

      <div className="admin-settings-content">
        <div
          className={
            isWideContent
              ? "admin-settings-content-inner admin-settings-content-inner--wide"
              : "admin-settings-content-inner"
          }
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};
